module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-05@2x.2b4c46d7.jpg";